import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authApi = axios.create({ baseURL: API });

// Attach admin token to protected calls automatically
authApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ordo-admin-token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const login = async (email, password) => {
  const { data } = await authApi.post("/auth/login", { email, password });
  localStorage.setItem("ordo-admin-token", data.token);
  localStorage.setItem("ordo-admin-email", data.email);
  return data;
};

export const logout = () => {
  localStorage.removeItem("ordo-admin-token");
  localStorage.removeItem("ordo-admin-email");
};

export const me = () => authApi.get("/auth/me").then((r) => r.data);

export const getContent = () => authApi.get("/content").then((r) => r.data);

export const updateContent = (data) =>
  authApi.put("/admin/content", { data }).then((r) => r.data);

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await authApi.post("/admin/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { id, url }
};

export const listMessages = () =>
  authApi.get("/admin/messages").then((r) => r.data);

export const isAuthed = () => !!localStorage.getItem("ordo-admin-token");
